import React, { useState, useEffect, useRef, useContext } from 'react';
import banner from 'apis/banner/banner';
import { toast } from "react-toastify";
import Carousel from 'components/Carousel/Carousel';
import Context from 'context/context';
// import CarouselSettingsModal from './CarouselSettingsModal';
import settingsApi from 'apis/settings/settings';
import * as moment from 'moment';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Loader from "components/Loader/CenteredLoader";
import { useHistory, useLocation } from "react-router";
import ReactExport from "react-data-export";
import language from 'apis/language/language';

const xlsx = require('xlsx');

const TargetBannerUploader = () => {
  const { state, dispatch } = useContext(Context);
  const { getTargetAccountsBanner, uploadTargetAccounts, updateTargetAccounts } = banner(); // Make sure update method exists in your API
  const { editSettings } = settingsApi();
  const editRef = useRef(null);
  const currentDate = moment().format('YYYY-MM-DD');
  const [loading, setLoading] = useState(false);
  const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
  const history = useHistory();

  const [states, setStates] = useState({
    file: null,
    fileType: '',
    fileName: '',
    type: 'Shipto_based',
    status: '',
    coverUrl: '',
    selectedBanner: null,
    bannerList: [],
    isCreateBtnClicked: false,
    startdate: moment().format('YYYY-MM-DD'),
    enddate: "",
    uploadedTargetData: [],
    removeTargetData: [],
    language: 'Both'

  });

  const {
    file,
    fileType,
    fileName,
    type,
    status,
    coverUrl,
    selectedBanner,
    bannerList,
    isCreateBtnClicked,
    startdate,
    enddate,
    uploadedTargetData,
    removeTargetData,
    language
  } = states;
   const multiDataSet = [
    {
      columns: [{ title: "shipto", style: { font: { bold: true } } }],
      data: [], // No row data needed if only heading
    },
  ];

  const [showModal, setShowModal] = useState(false);
  const [carouselSettings, setCarouselSettings] = useState({
    interval: null,
    animationType: '',
  });

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const response = await getTargetAccountsBanner();
      setStates({ ...states, bannerList: response?.data });
      setCarouselSettings({ interval: response?.bannerInterval, animationType: response?.bannerStyle })
    } catch (error) {
      console.error("Failed to fetch banner images:", error);
    }
  };



  const updateConfig = async () => {
    try {
      let values = {
        banner_interval: carouselSettings.interval,
        banner_style: carouselSettings.animationType
      }
      const response = await editSettings(values);
      if (response) {
        toast.success('Updated Successfully');
      }
    } catch (error) {
      console.error("Failed to fetch banner images:", error);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setStates({
      ...states,
      file: file,
      fileName: file.name,
      fileType: file.type
    });    
  };


  const handleEditClick = () => {
    if (editRef.current) {
      editRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      // Optional highlight effect
      editRef.current.classList.add("highlight");
      setTimeout(() => {
        editRef.current.classList.remove("highlight");
      }, 1500);
    }
  };

  useEffect(() => {
    handleEditClick();
  }, [isCreateBtnClicked, selectedBanner]);

  const handleBannerClick = (banner) => {
    const { file_name, is_active, cover_url, type, start_date, end_date,language } = banner;
    setStates({
      ...states,
      selectedBanner: banner,
      fileName: file_name,
      status: is_active ? 'true' : 'false',
      coverUrl: cover_url,
      type: type,
      file: null,
      startdate: start_date,
      enddate: end_date,
      language: org === "Henry Schein Canada" ? (language || 'Both') : null  

    });
  };

  const handleUpload = async () => {
    if (!file && !selectedBanner) {
      toast.error('No file selected');
      return;
    }
setLoading(true)
    const formData = new FormData();
    if (file) {
      formData.append('file', file);
      formData.append('fileName', fileName);
      formData.append('fileType', fileType);
      formData.append('type', type);
      formData.append('coverUrl', coverUrl);
      formData.append('status', true);
      formData.append('startdate', startdate);
      formData.append('enddate', enddate);
       if (org === "Henry Schein Canada") {
    formData.append('language', states.language);
  }
      const uniqueValues = [...new Set(Object.values(uploadedTargetData))];

      for (let i = 0; i < uniqueValues.length; i++) {
        formData.append('targetAccounts', uniqueValues[i]);
      }
      const uniqueValuesRemove = [...new Set(Object.values(removeTargetData))];

      for (let i = 0; i < removeTargetData.length; i++) {
        formData.append('removetargetAccounts', uniqueValues[i]);
      }
    
    
    }
    try {



      if (selectedBanner) {
        let values;
        const uniqueValues = [...new Set(Object.values(uploadedTargetData))];

        values = {
          id: selectedBanner.id,
          fileName,
          status,
          type:  type,
          coverUrl,
          startdate,
          enddate,
          uniqueValues,
          removeTargetData,
          language: org === "Henry Schein Canada" ? language : null 

        };

        if (!status) {
          toast.error("Please select the Status");
        setLoading(false)

          return;
        }

        if (org == "Henry Schein Dental" &&(!type ||type =='Select')) {
          toast.error("Please select the Type");
        setLoading(false)

          return;
        }



        if (enddate && moment(startdate).isAfter(moment(enddate))) {
          toast.error("Start date should be less than or equal to End date");
        setLoading(false)

          return;
        }
      
        if (startdate?.toString() === "Invalid Date") {
          toast.error("Invalid date.", {
            toastId: "invalid-date",
          });
        setLoading(false)

          return

        }




        let ress = await updateTargetAccounts(values);
        setLoading(false)

        if (ress.type == "error") {
          toast.error(ress.message);
          return;

        }

        // if(ress.message =="Next active banner is too far. Cannot deactivate the last active banner without another active or upcoming banner."){
        //   toast.error("Next active banner is too far. Cannot deactivate the last active banner without another active or upcoming banner.");
        //   return;

        // }// Make sure your backend accepts this format
        toast.success("Banner updated successfully");
      } else {
        if ( org == "Henry Schein Dental" && (!type ||type =='Select')) {
          toast.error("Please select the Type");
        setLoading(false)

          return;
        }
     
        // if (!status) {
        //   toast.error("Please select the Status");
        //   return;
        // }

        if (enddate && moment(startdate).isAfter(moment(enddate))) {
          toast.error("Start date should be less than or equal to End date");
        setLoading(false)

          return;
        }
   
        if (startdate?.toString()?.toLowerCase() == "invalid date") {
          toast.error("Invalid date.", {
            toastId: "invalid-date",
          });
        setLoading(false)

          return;

        }
        // if(uploadedTargetData&&Object.keys(uploadedTargetData).length==0){
        //   toast.error("Upload the target Accounts");

        // }

        let res = await uploadTargetAccounts(formData);
        setLoading(false)
        if (res.message == "Banner upload successfully") {
          toast.success("Uploaded successfully");

        }
      }
      setTimeout(function () {
        window.location.reload();
      }, 1000);
    } catch (err) {
      console.error('Upload error:', err);
       setLoading(false)
      // alert('Upload failed');
    }
  };
  function handleChange(file, category) {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (e) => {
        try {
          const data = e.target.result;
          const workbook = xlsx.read(data, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
      
          if (!sheetName) {
            return resolve([]);
          }
      
          const worksheet = workbook.Sheets[sheetName];
      
          if (!worksheet) {
            return resolve([]);
          }
      
          const json = xlsx.utils.sheet_to_json(worksheet, { header: 1 });

      
          if (!Array.isArray(json)) {
            return resolve([]);
          }
      
          const flat = json.flat(); // flatten rows into a single array of cells
      
          if (!Array.isArray(flat)) {
  
            return resolve([]);
          }
      
          const res = flat.map((cell) => cell?.toString?.() ?? ""); // safely convert each cell to string
   
      
          resolve(res);
        } catch (err) {
         
          reject(err);
        }
      };
      
    });

    promise.then((d) => {
      let arr= []
      for (let i = 0; i < Object.keys(d).length; i++) {
        let val = d[i];
        let numVal = Number(val); // Convert to number

 

    if (!isNaN(numVal) && numVal >= 1000) {
      arr.push(numVal); // Use the number version
    }
      }
   
      if(category=='ADD'){
        handleOnChange('uploadedTargetData',  arr);
      }
      if(category=='REMOVE'){
        handleOnChange('removeTargetData',  arr);
      }
      
    });
  }

  const handleReset = () => {
    setStates({
      ...states,
      file: null,
      type: 'Shipto_based',
      fileName: '',
      fileType: '',
      selectedBanner: null,
      status: '',
      coverUrl: '',
      isCreateBtnClicked: false,
      startdate: "",
      enddate: "",
      uploadedTargetData:[],
      removeTargetData:[],
      language: 'Both'

    })
    editRef.current = null;
  };

 

  const handleOnChange = (key, value) => {
    setStates({ ...states, [key]: value });
  }
  const handleDownload = () => {
    document.getElementById("hiddenDownloadBtn").click();
  };
  const org = state?.userInfo?.loyalty_organization_name;

  return (
    <div className="banner-uploader">
      <style>{`
        .banner-uploader {
          max-width: 960px;
          margin: 40px auto;
          font-family: sans-serif;
          padding: 0 20px;
        }
        .banners-grid {          
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 20px;
          margin-bottom: 40px;
        }
        .banner-card {
          background: #fff;
                    
          overflow: hidden;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          cursor: pointer;
          transition: transform 0.3s ease;
          padding: 13px;
        }
        .banner-card:hover {
          transform: translateY(-2px);
        }
        .banner-card img {
          width: 100%;
          height: 100px;
          object-fit: cover;
        }
        .form-container {
          background: #fff;
          border: 1px solid #ddd;
          padding: 24px;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
          transition: background-color 0.5s,
        }
        .drop-area {
          border: 2px dashed #ccc;
          height: 160px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #777;
          cursor: pointer;
          margin-bottom: 16px;
        }
        .form-input,
        .form-textarea,
        select {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #ccc;
          border-radius: 6px;
          margin-bottom: 16px;
          font-size: 14px;
        }
        .button-group {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
        .btn {
          padding: 8px 16px;
          border: none;
          border-radius: 6px;
          font-size: 14px;
          cursor: pointer;
        }
        .btn.cancel {
          background: #f3f3f3;
          color: #333;
        }
        .btn.upload {
          background: #2563eb;
          color: white;
        }
        .btn:disabled {
          background: #a0aec0;
          cursor: not-allowed;
        }
        .drop-area.disabled {
          background-color: #f9f9f9;
          border-color: #ccc;
          opacity: 0.6;
          pointer-events: none;
          cursor: not-allowed;
        }
      `}</style>

      <div style={{ display: 'flex', justifyContent: "space-between", marginBottom:"10px"}}>
        {/* <h2 className="section-title">Signature Banner & Preview</h2> */}
        <div>
          <button
            style={{ padding: "5px 10px", background: "#0a72ba", cursor: 'pointer', border: "none", borderRadius: 5, color: "#fff", height: 30 }}
            onClick={() => {
              setStates({ ...states, isCreateBtnClicked: true });
            }}
          >
            Upload
          </button>
          {/* <button
            style={{ marginLeft: 5, padding: "5px 10px", background: "#0a72ba", cursor: 'pointer', border: "none", borderRadius: 5, color: "#fff", height: 30 }}
            onClick={() => setShowModal(true)}
          >
            Settings
          </button> */}
        </div>
      </div>

      <div className="banners-grid">
        <Carousel autoPlay={false} displayArrow={true} animationType='slide'>
          {bannerList.map((banner) => (
            <div key={banner.id} className="banner-card">
              <img src={banner.url} alt={banner.title} style={{ objectFit: 'cover' }} />
              <div className="info">
                <h3><strong>{`File Name: `}</strong>{banner.file_name}</h3>
                <div>
                  <strong>{`Uploaded: `}</strong>
                  {new Date(banner?.updatedAt).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </div>
                {org == "Henry Schein Dental" && <div>
                  <strong>{`Type: `}</strong>
                  {banner?.type == "Loyalty_id_based" ? "Loyalty Id" : banner?.type == "Billto_based" ? "Billto" : "Shipto"}
                </div>}
             
                {/* <div>
                  <strong>{`Start Date: `}</strong><span>{banner?.start_date ? moment(banner?.start_date).format('MM/DD/YYYY') : "-"}</span>
                </div> */}
                {/* <div>
                  <strong>{`End Date: `}</strong><span>{banner?.end_date ? moment(banner?.end_date).format('MM/DD/YYYY') : "-"}</span>
                </div> */}
                {org === "Henry Schein Canada" && (
                  <div>
                    <strong>Language: </strong>
                    <span>{banner?.language ? banner.language : '-'}</span>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <strong>{`Status: `}</strong><span style={banner?.is_active == true ? { color: 'green' } : { color: 'red' }}>{`${banner?.is_active == true ? 'Active' : 'Inactive'}`}</span>
                  </div>

                  <button
                    style={{ padding: "5px 10px", background: "#0a72ba", cursor: 'pointer', border: "none", borderRadius: 5, color: "#fff" }}
                    onClick={() => handleBannerClick(banner)}>
                    Edit
                  </button>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>

      {(selectedBanner || isCreateBtnClicked) && <div className="form-container" ref={editRef}
        id="edit-section">
        <h2>{selectedBanner ? "Edit Banner" : "Upload New Promotion Banner"}<span style={{ color: 'red' }}>*</span></h2>

        <label htmlFor="file-upload" className={`drop-area ${selectedBanner ? 'disabled' : ''}`}>
          {file ? (
            <img
              src={URL.createObjectURL(file)}
              alt="Preview"
              style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
            />
          ) : selectedBanner ? (
            <img
              src={selectedBanner.url}
              alt="Selected"
              style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
            />
          ) : (
            <div>
              <p>Drag & drop banner image here</p>
              <p style={{ fontSize: '12px', color: '#aaa' }}>or click to browse (JPG, PNG, max 5MB, Resolution (1927x275))</p>
            </div>
          )}
        </label>
        <input
          key={file ? file.name : "default"}
          id="file-upload"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ display: 'none' }}
          disabled={!!selectedBanner}
        />

        
          <>
            <span style={{ marginLeft: "6px" }}>
              {('Select Target Type')} <span style={{ color: 'red', fontSize: "21px" }}>*</span> :
            </span>

            <select
              className="form-input"
              value={type}
              onChange={(e) => {
                const value = e.target.value;
                handleOnChange('type', value);
              }}
              required
              disabled={true}
            >
              <option selected>Select</option>
              {/* <option value="Loyalty_id_based">Loyalty Id</option>
              <option value="Billto_based">Billto</option> */}
              <option value="Shipto_based">Shipto</option>
            </select>
          </>
        
        <span style={{ marginLeft: "6px" }}>{('Redirection Url (Optional)')} : </span>
        <textarea
          className="form-textarea"
          // placeholder="Redirection Url"
          value={coverUrl}
          onChange={(e) => {
            let value = e.target.value;
            handleOnChange('coverUrl', value);
          }}
        />
        {org === "Henry Schein Canada" && (
  <>
    <span style={{ marginLeft: "6px" }}>
      Language <span style={{ color: 'red', fontSize: "21px" }}>*</span> :
    </span>

    <select
      className="form-input"
      value={language}
      onChange={(e) => handleOnChange('language', e.target.value)}
    >
      <option value="Both">Both</option>
      <option value="English">English</option>
      <option value="French">French</option>
    </select>
  </>
)}
 {selectedBanner && (
          <>
            <span style={{ marginLeft: "6px" }}>{('Select Status')} <span style={{ color: 'red', fontSize: "21px" }}>*</span>: </span>
            <select
              className="form-input"
              value={status}
              onChange={(e) => {
                let value = e.target.value;
                handleOnChange('status', value);
              }}
            >
              {/* <option value="" disabled hidden>Select Status</option> */}
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select> </>)}
            

          <>
            <span style={{ marginLeft: "6px" }}>
             {(selectedBanner?'ADD Target Accounts':'Upload Target Accounts')} {!selectedBanner&&<span style={{ color: 'red', fontSize: "21px" }}>*</span>} :
            </span>

            <input
                    id={'Target Accounts'}
                    className="form-input"
                    type="file"
                    accept=".xlsx"
                    placeholder="import csv"
                    onChange={(event) => {
                   
                      if (event.target.files[0])
                        handleChange(event.target.files[0], 'ADD');
                     }
                  }
                  />
          
          </>
        
            {selectedBanner && (
          <>
            <span style={{ marginLeft: "6px" }}>
             {('Remove Target Accounts')}  :
            </span>

            <input
                    id={'Target Accounts'}
                    className="form-input"
                    type="file"
                    accept=".xlsx"
                    placeholder="import csv"
                    onChange={(event) => {
                
                      if (event.target.files[0])
                        handleChange(event.target.files[0], 'REMOVE');
                     }
                  }
                  />
          </>
        )}
                <div>
      <span
        onClick={handleDownload}
        style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
      >
        click here to download sample file
      </span>

      <ExcelFile
        filename={"Sample file"}
        element={
          <button id="hiddenDownloadBtn" style={{ display: "none" }}>
            Hidden Download Button
          </button>
        }
      >
        <ExcelSheet dataSet={multiDataSet} name="Sheet1" />
      </ExcelFile>
    </div>

        <div className="button-group">
        {selectedBanner&&  <button className="btn upload" onClick={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
             history.push('/dashboard/target-accounts', { id: selectedBanner.id,data:[]})
          }}>View Target Accounts</button>
        }
          <button className="btn cancel" onClick={() => {
            handleReset();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}>Cancel</button>
           {loading ? <button
            className="btn upload"
          >
           Loading...
          </button> : 
           <button
           className="btn upload"
           onClick={handleUpload}
           disabled={!file && !selectedBanner}
         >
           {selectedBanner ? "Update Banner" : "Upload Banner"}
         </button>}
         
       
        </div>
      </div>}

      {/* <CarouselSettingsModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onChange={(key, value) => setCarouselSettings({ ...carouselSettings, [key]: value })}
        props={carouselSettings}
        onSave={updateConfig}
      /> */}
    </div>
  );
};

export default TargetBannerUploader;
